export default "__VITE_ASSET__BaDBbm8l__"